export default {
    copyMigrateModal: {
        title: 'Kopiraj {count} intervalov iz {date}',
        source: 'Vir: {date} (vsota {sum})',
        selectTargets: 'Izberite ciljne dneve (prikazan je predogled prepisa):',
        lengthMismatch: 'Neujemanje dolžine DST — intervali bodo skrajšani ali dopolnjeni',
        overwriteWarning: '{count} izbranih dni ima obstoječe spremembe, ki bodo prepisane:',
        confirmCopy: 'Potrdi kopiranje ({count})',
    },
}
